import React from 'react';
import * as S from './company-button.styles';

export const CompanyButton = ({ companyName }: { companyName: string | undefined }) => {
    return <div>{companyName && <S.CompanyButton variant="outlined">{companyName}</S.CompanyButton>}</div>;
};
